export default __webpack_public_path__ + "static/media/NewBadgeRight.02fe4d0b.gif";